/* Swipeable product card photos: marks the dot of the photo in view while the photos are swiped */

class GmCardSwipe extends HTMLElement {
  connectedCallback() {
    this.strip = this.closest('.product-card__figure')?.querySelector('.product-card__media--swipe');
    if (!this.strip) return;

    this.onScroll = () => {
      const index = Math.round(this.strip.scrollLeft / this.strip.clientWidth);
      [...this.children].forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };

    this.strip.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.strip?.removeEventListener('scroll', this.onScroll);
  }
}

if (!customElements.get('gm-card-swipe')) {
  customElements.define('gm-card-swipe', GmCardSwipe);
}
